export default __webpack_public_path__ + "static/media/allCertificates.6ecfd5a7.png";